
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h2>Harshita Gautam </h2>
				</div>
			</div>
		</div>
	</div>
  <div class="breadcrumb-bottom-img">
    <img
        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
</div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center">
      <h2>View Details For Harshita <span >Gautam</span></h2>
    </div>
    <div class="row">
      <div class="col-md-5">
        <div class="img-dance text-center">
          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/harshita-gautam.jpg"
            class="img-fluid">
        </div>
      </div>
      <div class="col-md-7">
        <div class="p-2"></div>
        <form>
          <input type="hidden" id="CUST_ID" name="CUST_ID" value="{{data.id}}">
          <input type="hidden" class="form-control" id="TXN_AMOUNT" name="TXN_AMOUNT" value="{{data.payamount}}">
          <input type="hidden" class="form-control" id="college" name="college" value="{{data.instituteName}}">

          <input type="hidden" class="form-control" id="STUDENT_NAME" name="STUDENT_NAME" value="{{data.name}}">

          <input type="hidden" class="form-control" id="COLLEGE_ID" name="COLLEGE_ID" value="{{data.instituteName}}">

          <input type="hidden" class="form-control" id="ORDER_ID" name="ORDER_ID" value="ORDER{{randNumber}}" readonly>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Name of Candidate:</label>
            <div class="col-sm-8">
              <input type="text" placeholder="Name of Candidate" formControlName="candidateName" name="candidateName"
                class="form-control" value="{{data.name}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">E-mail:</label>
            <div class="col-sm-8">
              <input type="email" formControlName="email" name="email" placeholder="Email" class="form-control"
                value="{{data.email}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Whatsapp Number:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="phone" name="phone" minlength="10" maxlength="10"
                placeholder="Phone Number" class="form-control" value="{{data.phone}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">City:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="city" name="city" placeholder="City" class="form-control"
                value="{{data.city}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">School/College/Academy:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="sttype" name="sttype" placeholder="Sttype" class="form-control"
                value="{{data.sttype}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Choose Academy:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="chooseAcademy" name="chooseAcademy" placeholder="Choose Academy"
                class="form-control" value="{{data.chooseAcademy}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">School/College/Academy Name:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="instituteName" name="instituteName" placeholder="Choose Academy"
                class="form-control" value="{{data.instituteName}}" readonly>
            </div>
          </div>
          <div class="form-group row mb-3" id="nc_signup">
            <label class="control-label col-sm-4">Pay Amount:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="payamount" name="payamount" placeholder="Choose Academy"
                class="form-control" value="{{data.payamount}}" readonly>
            </div>
          </div>
          <div class="form-group row justify-content-center mb-3">
            <div class="col-sm-offset-2 col-sm-3">
              <input type="submit" name="submit" class="w-100 btn button--effect-2 mx-2 btn-color" value="Register"
                readonly>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
